import { Card, CardContent, CardHeader, Grid, TextField } from "@bvhi/ui-base";
import { useTranslation } from "react-i18next";
import { FormTextFieldEMail } from "../../../../components/common/form-text-field-e-mail";
import { FormTextFieldEMailConfirmation } from "../../../../components/common/form-text-field-e-mail-confirmation";
import { useAuthContext } from "../../../../context/use-auth-context";

export const UpdateEmailCard = () => {
  const { currentUser } = useAuthContext();
  const { t } = useTranslation(["users", "profile"]);

  return (
    <Card elevation={0}>
      <CardHeader subheader={t("profile:profile.update.email.card.sub.title")} title={t("profile:profile.update.email.card.title")} />
      <CardContent>
        <Grid container spacing={2}>
          <Grid xs={12}>
            <TextField
              disabled
              fullWidth
              label={t("profile:profile.current.email.card.email.label")}
              sx={{ pb: 3 }}
              value={currentUser?.email ?? ""}
            />
          </Grid>
          <Grid xs={12}>
            <FormTextFieldEMail inputProps={{ autoComplete: "email" }} />
          </Grid>
          <Grid xs={12}>
            <FormTextFieldEMailConfirmation
              onPaste={(e) => {
                e.preventDefault();
              }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
